<template>
  <div>
    <div class="ahead-tabs" v-if="showDrug">
      <div class="ahead-tabs-item" :class="{ active: aheadActiveTab === 'article' }" @click="handleAheadTab('article')">科普文章</div>
      <div v-if="showDrug" class="ahead-tabs-item" :class="{ active: aheadActiveTab === 'drug' }" @click="handleAheadTab('drug')">药品信息</div>
    </div>
    <div v-show="aheadActiveTab === 'article'">
      <div class="searchText maxWidth hideInPC">
        <select v-model="selectedSearchType" >
          <option  value="content">全文</option>
          <option value="title">标题</option>
          <option  value="author">作者</option>
        </select>
        <input type="text" placeholder="可查询疾病、症状或作者" v-model="searchKey" @keyup.enter="searchText" v-focus="isFocusSearch">
        <span class="searchBtn" @click="searchText">🔍 </span>
      </div>
      <div class="catoryBox">
        <img  src="../assets/search.png" alt="" class="globalSearchIcon hideInMobile"/>
        <div class="tag hideInPC active">所有科室</div>
        <div class="tag" :class="{'active': (selectedCatory == category.id)}" v-for="category in categoryList" :key="category.id" @click="tapTheTag(category)" v-if="category.showFlag">{{category.name}}</div>
        <div class="subCategoryBox" v-if="showSubCategory">
          <div class="wrap subTitleWrap">
            <!--<img src="../assets/CLOSE2.png" class="closeSubCategoryBoxBtn" alt="" @click="closeSubTitleWrap()">-->
            <div class="subBox" v-for="subCategory in subCategoryList" :key="subCategory.id">
              <div class="subTitle">{{subCategory.name}}</div>
              <div class="subContentBox">
                <div class="subContent" :class="{'activeSubCatalog': (selectedSubCatory == catalog.id)}" v-for="catalog in subCategory.catalogs" :key="catalog.id" @click="selectedSubContent(catalog, subCategory)">
                {{catalog.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="flex-center hideInMobile" style="height:2.5rem;margin-top: 8px;">
          <div class="searchText maxWidth " style="width:55%;">
            <select v-model="selectedSearchType" >
              <option  value="content">全文</option>
              <option value="title">标题</option>
              <option  value="author">作者</option>
            </select>
            <input type="text" placeholder="可查询疾病、症状或作者" v-model="searchKey" @keyup.enter="searchText" v-focus="isFocusSearch">
            <span class="searchBtn" @click="searchText">🔍 </span>
          </div>
        </div>
        <div class="articleList">
          <div class="article" v-for="article in articleList" :key="article.id" @click="turnToArticle(article)">
          <img :src="article.thumb" alt="" class="hideInMobile">
            <div class="infoBox">
              <div class="title"><div class="author" v-if="article.author">{{article.author}} : </div>{{article.title}}</div>
              <div class="desc hideInMobile">{{article.digest}}</div>
            </div>
          </div>
        </div>
        <div class="loadmore" @click="loadmoreArticle" v-if="hasNext">加载更多...</div>
      </div>
    </div>
    <div v-show="showDrug && aheadActiveTab === 'drug'">
      <div class="catoryBox">
        <img  src="../assets/search.png" alt="" class="globalSearchIcon hideInMobile"/>
        <div
          class="tag"
          v-for="tag in drugTag"
          :class="{'active': selectDrugTag === tag}"
          :key="tag"
          @click="tapTheDrugTag(tag)"
          style="min-width: unset;"
        >
          {{tag}}
        </div>
      </div>
      <div class="wrap">
        <div class="flex-center" style="height:2.5rem;margin-top: 8px;">
          <div class="searchText maxWidth " style="width:55%;">
            <input type="text" placeholder="可查询药品名称" v-model="drugSearchKey" @keyup.enter="searchDrug">
            <span class="searchBtn" @click="searchDrug">🔍 </span>
          </div>
        </div>

        <div class="articleList">
          <div class="article" v-for="drug in drugList" :key="drug.id" @click="turnToDrug(drug)">
            <img :src="drug.imageUrl || 'https://file-storage.distinctclinic.com/miniapp/static/default_drugs.jpg'" alt="">
            <div class="infoBox">
              <div class="title">
                {{drug.productName}}
              </div>
            </div>
          </div>
        </div>
        <div class="loadmore" @click="loadMoreDrug" v-if="drugHasNext">加载更多...</div>
      </div>
    </div>
  </div>
</template>
<style  lang="less" scoped>
  @import '../style/page.less';
</style>
<script>
import axios from "axios";
import common from "../common";
export default {
  name: "",
  data() {
    return {
      host: common.network.v2host,
      v1host: common.network.host,
      baseHost: common.network.baseHost,
      categoryList: [],
      categoryId: "",
      subCategoryList: [],
      articleList: [],
      hasNext: false,
      selectedCatory: '',
      selectedSubCatory: '',
      showSubCategory: false,
      getArticleParams: {
        searchKey: '',
        type: 'content',
        start: 0,
        limit: 20,
        catalogId: ''
      },
      selectedSearchType: 'content',
      searchKey: '',
      subCategoryName: '',
      isFocusSearch: false,
      aheadActiveTab: 'article', // article, drug
      drugTag: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      selectDrugTag: 'A',
      drugSearchKey: '',
      drugStart: 0,
      drugList: [],
      drugHasNext: false,

      showDrug: false,
    }
  },
  created() {
    if(this.$route.query && this.$route.query.drug) {
      this.showDrug = this.$route.query.drug ? true : false;
      this.handleAheadTab('drug')
    }
  },
  mounted: function() {
    console.log('测试自动发版-1')
    if (this.$route.query.searchKey) {
      this.searchKey = this.$route.query.searchKey
      this.getArticleParams.searchKey = this.$route.query.searchKey
    }
    if (this.$route.query.tab) {
      this.handleAheadTab(this.$route.query.tab)
    }
    axios({
      method: "get",
      url: this.host + "available_services",
      data: {}
    }).then(res => {
        if (res.status === 200) {
          this.categoryList = res.data;
          return axios({
            method: "get",
            url: this.v1host + "config"
          })
        }
    }).then(res => {
      let randomKeyWord = res.data.defaultSearchKey[Math.floor(Math.random()*res.data.defaultSearchKey.length)]
      this.searchKey = randomKeyWord
      this.getArticleParams.searchKey = randomKeyWord
      return this.getArticle(this.getArticleParams, true)
    })
  },
  methods: {
    getArticle: function(parms, clear) {
      let self = this;
      if (clear) {
        // this.getArticleParams.searchKey = ''
        // this.searchKey = ''
        this.getArticleParams.type = 'content',
        this.getArticleParams.start = 0
        self.articleList = []
      }
      axios({
        method: "get",
        url: self.host + "articles",
        params: parms
      }).then(res => {
        if (res.status === 200 ) {
          if (self.getArticleParams.start == 0) {
            self.articleList = res.data.articles.data;
          } else {
            self.articleList = self.articleList.concat(res.data.articles.data);
          }
          self.articleList.forEach(item=>{
            item.thumb = self.processWechatImg(item.thumb)
          })
          self.hasNext = res.data.articles.hasNext;
          if (self.hasNext) {
            self.getArticleParams.start += self.getArticleParams.limit;
          }
        }
      });
    },
    tapTheTag: function(item) {
      if (this.selectedCatory == item.id && this.subCategoryList.length != 0) {
        this.showSubCategory = !this.showSubCategory
        return
      }
      this.selectedSubCatory = ''
      this.subCategoryName = ''
      this.getArticleParams.start = 0;
      this.selectedCatory = item.id
      this.$router.push(`/v3/article_page/?category=${this.categoryName}`)
      // this.getSubTitle(item)
      // this.getArticleParams = {
      //   ...this.getArticleParams,
      //   catalogId: item.id
      // }
      // this.getArticle(this.getArticleParams, true);
    },
    turnToArticle: function(article) {
      let self = this;
      let parms = {
        utmSource: 'pc',
        utmMedium: 'full-text' ,
        utmContent: '',
        utmTerm: this.searchKey ? this.searchKey : '',
        utmCampaign: article.title,
        articleId: article.id
      }
      axios({
        method: "get",
        url: self.host + "link/" + article.id,
        params: parms,
        headers: {
          platform: 'pc'
        }
      }).then(res => {});
      window.open(article.link);
    },
    loadmoreArticle: function() {
      // this.getArticleParams.start += this.getArticleParams.limit;
      this.getArticle(this.getArticleParams);
    },
    processWechatImg: function(urlText) {
        var url = urlText+'X',
            time = new Date().getTime(),
            frameid = 'wechatImg_' + time;
        window.WechatImgTemp = '<img id="img" style="width:100%" src=' + url + '?' + time + ' />';
        var iframe = '<iframe id="' + frameid + '"  src="javascript:parent.WechatImgTemp;" frameBorder="0" scrolling="no" width="100%"></iframe>';
        return url + '?0.' + time
        // jQele.after(iframe).remove()
    },
    searchText: function() {
      this.getArticleParams = {
        ...this.getArticleParams,
        type: this.selectedSearchType,
        catalogId: '',
        searchKey: this.searchKey,
        start: 0
      }
      this.selectedCatory = ''
      this.selectedSubCatory = ''
      this.subCategoryName = ''
      this.articleList = []
      this.getArticle(this.getArticleParams)
    },
    handleAheadTab(tab) {
      this.aheadActiveTab = tab;
      this.selectDrugTag = Boolean(this.drugSearchKey)
        ? this.selectDrugTag
        : this.selectDrugTag || 'A';
      this.fetchDrugList();
    },
    tapTheDrugTag(tag) {
      this.selectDrugTag = tag;
      this.drugStart = 0;
      this.drugSearchKey = '';
      this.fetchDrugList();
    },
    searchDrug() {
      this.drugStart = 0;
      this.selectDrugTag = '';
      this.fetchDrugList(true)
    },
    fetchDrugList() {
      axios({
        method: 'get',
        url: this.baseHost + "app-web2/search/drugs",
        params: {
          initials: this.drugSearchKey ? '' : this.selectDrugTag,
          searchKey: this.drugSearchKey ? this.drugSearchKey : '',
          start: this.drugStart,
          limit: 10
        }
      }).then(res => {
        if (res.status === 200 && res.data) {
          this.drugHasNext = res.data.hasNext || false;
          this.drugList = this.drugStart === 0
            ? res.data.data || []
            : this.drugList.concat(res.data.data || []);
        }
      })
    },
    loadMoreDrug() {
      this.drugStart += 10;
      this.fetchDrugList();
    },
    turnToDrug(drug) {
      if (!drug.link) {
        alert('暂无详情');
        return;
      }

      window.open(drug.link);
    }
  },
  computed: {
    categoryName: function() {
      let selectedCategoryName = ''
       this.categoryList.some((ele, index, arr) => {
          if (ele.id === this.selectedCatory) {
            selectedCategoryName = ele.name;
            return true;
          } else {
            return false;
          }
        })
      return selectedCategoryName
    }
  },
  directives: {
  focus: {
      // 指令的定义
      inserted: function (el) {
        el.focus()
      }
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/pages/globalSearchPageV3.vue